import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";

const ForgetPassword = (props) => {
  const navigate = useNavigate();
  const userEmailInputRef = useRef();

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  // var [generatedPassword, setGeneratedPassword] = useState('');
  // var generatedPassword = '';

  // const generatePassword = () => {
  //   const chars = '0123456789';
  //   var password = '';
  //   for (let i = 0; i < 6; i++) {
  //     const randomIndex = Math.floor(Math.random() * chars.length);
  //     password += chars[randomIndex];
  //   }
  //   generatedPassword = password;
  // };

  const generatePassword = () => {
    const length = 12; // Length of the password
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password;
    };
    const encryptPassword = (password) => {
        return common.c_EncryptData(password.trim()).toString();
    };


  const onKeyDown = (event) => { 
		if (event.key === "Enter") 
    sendBtnOnClick();
	}


  // useEffect(() => {
  //   var inputText = document.getElementById("EMAIL");
  //   var saveBtn = document.getElementById("btnSave");
  //   if (inputText && saveBtn) {
  //     inputText.onkeydown = (e) => { if (e.key === "Enter") saveBtn.click(); }
  //   }
  // }, [props.editData]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

  const sendBtnOnClick = () => {
    if (editData.EMAIL === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        EMAIL: ("Email could not be empty."),
      }));
    }
    if (Object.values(inputError).filter(v => v !== "").length === 0) {
      ForgetPassword();
    }
  }

  function ForgetPassword() {
    if (editData.EMAIL !== undefined) {
      let functionName = "";
      try {
        functionName = ForgetPassword.name;
        props.onLoading(true, "Sending email, please wait...");
        // var encrypted = common.c_EncryptData(generatedPassword);
        const generatedPassword = generatePassword();
        const encryptedPassword = encryptPassword(generatedPassword);
        const data = {
          EMAIL: editData.EMAIL,
          DEFAULT_PASSWORD: encryptedPassword.toString(),
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };
        http
          .post("api/login/ForgetPassword", data, { timeout: 5000 })
          .then((response) => {
            if (response.data.VALID === "EMAIL_INVALID") {
              setEditData(prevState => ({
                ...prevState,
                ERROR_MSG: response.data.ERROR_MSG,
              }))
            }
            else {
              toast.success("Forget password successfully. Please check your email.");
              hideModal();
              props.showHideLoginModal();
            }
          })
          .catch((err) => {
            toast.error("Failed to forget password. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        toast.error("Failed to forget password. Please try again.");
        props.onLoading(false, "Loading...");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  };


  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (name + " could not be empty."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title>FORGET PASSWORD</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <h5
            style={{
              fontSize: '1.25rem',
              fontWeight: '500', // Make it slightly bold for emphasis
              color: '#696969',
              textAlign: 'center',
              // marginTop: '20px',
              marginBottom: '15px',
              lineHeight: '1.6',
            }}
          >
            Enter the email address associated with your account, and we'll send you a password reset link.</h5>
          <Comp.Input
            ref={userEmailInputRef}
            id="EMAIL"
            label={<span style={{ fontWeight: 'bold', color: '#D2691E' }}>Email Address*:</span>}
            name="Email"
            type="text"
            className="form-control"
            errorMessage={inputError.EMAIL}
            value={editData.EMAIL}
            onChange={inputRequiredHandler}
            onKeyDown={onKeyDown}
          />

        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={hideModal}
            >
              Cancel
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnSave" onClick={sendBtnOnClick}>
              Confirm
            </Comp.Button>
            
            {editData.ERROR_MSG && editData.ERROR_MSG.split('\n').map((line, index) => (
              <p key={index} style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{line}</p>
            ))}
            {/* <p style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{editData.ERROR_MSG}</p> */}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ForgetPassword;